// extracted by mini-css-extract-plugin
module.exports = {"list":"career-stats-citations_list__g4tHH","item":"career-stats-citations_item__HFW5a"};